import type { ServiceRequest } from '@medplum/fhirtypes';

import { isRejected } from './review-markers';

/**
 * Pure page-side derivation for the Patient to-dos card: which fetched
 * ServiceRequests are visible. Reviewer-rejected proposals keep
 * `status: active` (the decide transition only swaps the review-status tag),
 * so visibility is a client-side filter on top of the status-filtered read.
 */

/** Fetched to-dos minus reviewer-rejected proposals, open before completed. */
export function visibleTodos(todos: ServiceRequest[]): ServiceRequest[] {
  const kept = todos.filter((todo) => !isRejected(todo));
  return [
    ...kept.filter((todo) => todo.status !== 'completed'),
    ...kept.filter((todo) => todo.status === 'completed'),
  ];
}

/** The to-do's due date: occurrenceDateTime or the occurrence period's end.
 *  Plan activation writes no occurrence today — usually null. */
export function todoDueDate(todo: ServiceRequest): string | null {
  return todo.occurrenceDateTime ?? todo.occurrencePeriod?.end ?? null;
}
